import { compose, mapProps } from "recompose";
import withIsFeatureActive from "web/core/UNSAFE_featureFlags/withIsFeatureActive";
import { branchContributionModeEnabled } from "theme/modules/ContributionMode";

const RenderNull = () => {
  return null;
};

const EnhanceMagicButton = compose(
  withIsFeatureActive("xRayMode", "xRayMode"),
  withIsFeatureActive("previewMode", "previewMode"),
  mapProps((props) => {
    return {
      loading: props.previewMode.loading || props.xRayMode.loading,
      isPreviewModeEnabled: Boolean(props.previewMode.isFeatureActive),
      isXRayModeEnabled: Boolean(props.xRayMode.isFeatureActive),
    };
  }),
  branchContributionModeEnabled(
    (MagicButton) => MagicButton,
    (MagicButton) => RenderNull
  )
);

export default EnhanceMagicButton;
